import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,{staticClass:"select",attrs:{"disabled":_vm.disabled || _vm.internalLoading,"hide-details":_vm.hideDetails,"items":_vm.allOperations,"loading":_vm.loading || _vm.internalLoading,"value":_vm.value,"item-text":"name","return-object":"","label":"Tätigkeit","overflow":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }